import SharedI18n from "./sharedI18n";

const ru: SharedI18n = {
  namespace: "shared",
  table:{
    selected: "Выбрано",
    rows: "Строк на странице:",
    of: "из"
  },
  navmenu: {
    logo: "/image/Logo.ru.png",
    language: "English-US",
    exit: "Выход",
    documents: "Документы",
    admin: "Администрирование",
    company: "Организации",
    users: "Пользователи",
    usersGroup: "Группы пользователей",
    settings: "Параметры",
    downloads: "Загрузка...",
    downloadLogs: "Скачать логи",
    audit: "Протокол",
    profile: "Профиль",
    tasks: "Задачи",
    myTasks: "Мои задачи",
    myWork: "Моя работа",
    editableDocuments: "Редактируемые документы",
    showMore: "Показать больше",
    more: "Ещё",
    accessRestrictionStamp: "Грифы ограничения доступа",
  },
  breadcrumb: {
    home: "АСОНИКА-ЦДЭ",
    "/documents": "Документы",
    "/users": "Пользователи",
    "/usersGroup": "Группы пользователей",
    "/company": "Организации",
    "/settings": "Параметры",
    "/audit": "Протокол",
    "/profile": "Профиль",
    "/changePass": "Сменить пароль",
    "/changePersonalData": "Изменить персональные данные",
    "/changeAvatar": "Изменить аватар",
    "/tasks": "Задачи",
    "/editableDocuments": "Редактируемые документы",
    "/myTasks": "Мои задачи",
    "/accessRestrictionStamp": "Грифы ограничения доступа",
  },
  footer: {
    asonika: 'ООО "НИИ АСОНИКА"',
    site: "Сайт:",
    support: "Поддержка:",
    link: "http://asonika-online.ru",
  },
  dropmenu: {
    emptyLock: "Нет редактируемых документов",
    myTasks: "Мои задачи",
    docLock: "Редактируемые документы",
    undo: "Отменить редактирование файла",
    commit: "Завершить редактирование файла",
    toDocuments: "Перейти к документу"
  },
  statusList: {
    New: "Новая",
    Active: "В работе",
    Closed: "Закрыта",
    Resolved: "Завершена",
    Canceled: "Отменена",
    Paused: "Отложена",
  },
};

export default ru;
